import config from '@/api/config'

let subUrl = '/webview'

export default {
  getTexts: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/texts'
    }
  },
  getConfig: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/config'
    }
  },
  callWaiter: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/waiter/call'
    }
  }
}
